import React, { useState } from "react";

const holes = [
  {
    number: 1,
    men: "450 yards",
    women: "361 yards",
    par: 5,
    handicap: 2,
    desc: "A long opening hole with a straight fairway. Good for a strong drive to start your round.",
  },
  {
    number: 2,
    men: "383 yards",
    women: "307 yards",
    par: 4,
    handicap: 9,
    desc: "A moderate-length par 4. Play smart to set up a good approach to the green.",
  },
  {
    number: 3,
    men: "388 yards",
    women: "300 yards",
    par: 4,
    handicap: 5,
    desc: "Slightly longer par 4. Good accuracy off the tee is important.",
  },
  {
    number: 4,
    men: "507 yards",
    women: "389 yards",
    par: 5,
    handicap: 4,
    desc: "A long par 5 with challenges along the way. Best chance to reach the green in three shots.",
  },
  {
    number: 5,
    men: "398 yards",
    women: "338 yards",
    par: 4,
    handicap: 3,
    desc: "One of the tougher par 4s. A solid tee shot is key to make par.",
  },
  {
    number: 6,
    men: "351 yards",
    women: "295 yards",
    par: 4,
    handicap: 1,
    desc: "The hardest hole on the course. Requires accuracy and careful shot placement.",
  },
  {
    number: 7,
    men: "147 yards",
    women: "79 yards",
    par: 3,
    handicap: 6,
    desc: "Short par 3. Good chance for a birdie with a precise tee shot.",
  },
  {
    number: 8,
    men: "263 yards",
    women: "220 yards",
    par: 4,
    handicap: 8,
    desc: "A short par 4. Play safe or try to reach the green with one big shot.",
  },
  {
    number: 9,
    men: "133 yards",
    women: "107 yards",
    par: 3,
    handicap: 7,
    desc: "A short finishing hole. A nice chance to end the round with a good score.",
  },
];

const images = [
  "https://res.cloudinary.com/dxdvcplbl/image/upload/v1758730968/9_hole_golf_course_mdgxpx.jpg", // First image
  // "https://res.cloudinary.com/dxdvcplbl/image/upload/v1758648419/golf_course_wrhpbv.jpg", // Second image
];

const hoelsImages = [
  "https://res.cloudinary.com/dxdvcplbl/image/upload/v1758909165/1-01_gcjfrq.jpg",
  "https://res.cloudinary.com/dxdvcplbl/image/upload/v1758909165/2-01_gms3li.jpg",
  "https://res.cloudinary.com/dxdvcplbl/image/upload/v1758909165/3-01_jpopoh.jpg",
  "https://res.cloudinary.com/dxdvcplbl/image/upload/v1758909166/4-01_gbxugg.jpg",
  "https://res.cloudinary.com/dxdvcplbl/image/upload/v1758909165/5-01_jm6pua.jpg",
  "https://res.cloudinary.com/dxdvcplbl/image/upload/v1758909166/6-01_ipisvl.jpg",
  "https://res.cloudinary.com/dxdvcplbl/image/upload/v1758909166/7-01_wzfwey.jpg",
  "https://res.cloudinary.com/dxdvcplbl/image/upload/v1758909166/8-01_rozlxo.jpg",
  "https://res.cloudinary.com/dxdvcplbl/image/upload/v1758909166/9-01_bgoxhy.jpg",
];

const GolfCourse = () => {
  const [current, setCurrent] = useState(0);
  const [modalImg, setModalImg] = useState(null);

  const prevSlide = () => {
    setCurrent((prev) => (prev === 0 ? images.length - 1 : prev - 1));
  };

  const nextSlide = () => {
    setCurrent((prev) => (prev === images.length - 1 ? 0 : prev + 1));
  };

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col">
      {/* Page Title */}
      <h1 className="text-4xl font-bold text-center py-6 text-green-700 tracking-wide">
        9 Hole Golf Course
      </h1>

      <div className="flex flex-1 flex-col md:flex-row">
        {/* Left Section - Timeline */}
        <div className="w-full md:w-1/2 h-[80vh] overflow-y-auto flex flex-col items-center bg-gray-100 p-4">
          <div className="relative h-full w-full max-w-xl">
            {/* Image */}
            <img
              src={images[current]}
              alt={`Slide ${current + 1}`}
              className="rounded-xl shadow-lg w-full h-full object-cover cursor-pointer"
              onClick={() => setModalImg(images[current])}
            />

            {/* Left Button */}
            <button
              onClick={prevSlide}
              className="absolute top-1/2 left-3 -translate-y-1/2 bg-black text-white p-2 rounded-full shadow hover:bg-gray-700"
            >
              ❮
            </button>

            {/* Right Button */}
            <button
              onClick={nextSlide}
              className="absolute top-1/2 right-3 -translate-y-1/2 bg-black text-white p-2 rounded-full shadow hover:bg-gray-700"
            >
              ❯
            </button>
          </div>

          {/* Dots indicator */}
          <div className="flex space-x-2 mt-4">
            {images.map((_, i) => (
              <span
                key={i}
                onClick={() => setCurrent(i)}
                className={`h-3 w-3 rounded-full cursor-pointer ${
                  current === i ? "bg-green-600" : "bg-gray-400"
                }`}
              ></span>
            ))}
          </div>
          <p className="mt-6 text-gray-700 text-justify leading-relaxed px-4">
            Rangpur Golf and Country Club (RGCC) features a beautifully designed
            golf course surrounded by lush greenery and serene landscapes. The
            wide, open fairways are perfectly maintained, offering a smooth and
            enjoyable experience for golfers of all skill levels. Natural water
            bodies and tree-lined boundaries enhance the course’s beauty while
            adding a bit of challenge to each hole. The layout includes several
            greens and tees (like G-1 to G-9 and T-1 to T-9), thoughtfully
            arranged across the vast area. Its peaceful environment, combined
            with scenic views, makes it not just a golf destination but also a
            relaxing retreat. RGCC is truly a gem for both golfers and nature
            lovers in the heart of Rangpur.
          </p>
        </div>

        {/* Right Section - Scrollable with Slider */}
        <div className="w-full md:w-1/2 px-6 py-8  h-[80vh] overflow-y-scroll">
          <div className="relative border-l border-green-300">
            {holes.map((hole) => (
              <div key={hole.number} className="mb-10 ml-6">
                {/* Circle */}
                <span className="absolute -left-3 flex items-center justify-center w-6 h-6 bg-green-600 rounded-full ring-4 ring-white text-white text-sm font-bold">
                  {hole.number}
                </span>
                <div className="p-5 bg-white rounded-xl shadow-md hover:shadow-lg transition">
                  <h2 className="text-xl font-semibold text-green-700">
                    Hole {hole.number}
                  </h2>
                  <p className="text-sm text-gray-600 mt-1">
                    Men’s Tee: <span className="font-medium">{hole.men}</span> |
                    Women’s Tee:{" "}
                    <span className="font-medium">{hole.women}</span>
                  </p>
                  <p className="text-sm text-gray-600">
                    Par: <span className="font-medium">{hole.par}</span> |
                    Handicap Index:{" "}
                    <span className="font-medium">{hole.handicap}</span>
                  </p>
                  <p className="mt-2 text-gray-700 leading-relaxed">
                    {hole.desc}
                  </p>
                  {/* See Image Button */}
                  <button
                    onClick={() =>
                      setModalImg(hoelsImages[hole.number - 1] || images[0])
                    }
                    className="mt-3 bg-green-600 text-white px-4 py-2 rounded-lg shadow hover:bg-green-700 transition"
                  >
                    See Image
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Modal */}
      {modalImg && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-80 z-50">
          <img
            src={modalImg}
            alt="Large Preview"
            className="max-w-4xl max-h-[90vh] rounded-lg shadow-lg"
          />
          <button
            onClick={() => setModalImg(null)}
            className="absolute top-5 right-5 bg-white text-black p-2 rounded-full w-10 h-10 shadow hover:bg-gray-200"
          >
            ✕
          </button>
        </div>
      )}
    </div>
  );
};

export default GolfCourse;
